import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {API_BASE_URL} from "../../constants";
import Alert from "react-s-alert";
import LoadingIndicator from "../../common/LoadingIndicator";
import {Button, Dropdown, Menu} from 'antd';
import Icon from "antd/es/icon";
import {showAxiosError} from "../../util/Helpers";
import TalepDeleteModal from "./TalepDeleteModal"
import NobetTalepForm from "./NobetTalepForm"

class NobetTalep extends Component {

    constructor(props) {
        super(props);

        this.state = {
            requests: [],
            isModalVisible: false,
            request: null,
            error: null,
            loading: false,
            page: 0,
            currentPage: 1,
            pageSize: 10,

            note: true,
            add: false,
            currentUser:[],
            userId: null,
            selectedRequest: null,
            selectedItem: null,
            branches: null,
            roles: null,
            totalIdList: [],
            debtList: [],
            cities: null,
            citySubdivisions: null,
            searching: false,
            searchQuery: undefined,
            total: 0,
            size: 10,
            // manual: false,
            isEditModalOpen: false,
            addNoteModal: false,
            addIncomingModal: false,
            addTransferModal: false,
            addDeleteModal: false,
            action: '',
            isLoading: false,
        };
        this.cancelRequestCreation = this.cancelRequestCreation.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.fetchRequest = this.fetchRequest.bind(this);
    }

    componentDidMount() {
        this.fetchRequest()
    }



     fetchRequest(accessor, direction, page, size) {
            let self = this;
            let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,asc";
            let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
            let url;
            searchQuery = searchQuery.replaceAll('this.state.documentContent.', '');

            url = API_BASE_URL + "/nobettalep?page=" + page + "&size=" + size + sortStr + searchQuery;

            let params = {
                url: url,
                method: "get",
            };
            self.setState({loading: true,
                searching: true});
            request(params)
                .then(function (response) {
                    let totalChanged = false;
                    if (response.data.totalElements !== self.state.total) {
                        totalChanged = true;
                    }
                    self.setState({
                      page:page,
                      size: size,
                      total: response.data.totalElements,
                      requests: response.data.content,
                      totalIdList: response.data && response.data.content.map(request => request.id),
                      debtList: response.data.content.map(request => request.debt),
                          loading: false,
                    });
                }).catch(function (error) {
                self.setState({loading: false, searching: false, error: "Eczaneler yüklenirken bir sorun oluştu."});
                // showAxiosError(error);
            });
        }

    handleRequestDelete = (id, description) => {
      const isConfirmed = window.confirm(`${description} Talebinizi silmek istediğinizden emin misiniz?`);

         if (isConfirmed) {
               const token = localStorage.getItem("accessToken");
               const apiUrl = `${API_BASE_URL}/nobettalep/${id}`;


               fetch(apiUrl, {
                   method: "DELETE",
                   headers: {
                       Authorization: "Bearer " + token,
                   },
               })
                   .then((response) => {
                       if (!response.ok) {
                           throw new Error("Network response was not ok");
                       }
                       this.setState((prevState) => ({
                           requests: prevState.requests.filter((request) => request.id !== id),
                       }));
                   })
                   .catch((error) => {
                       console.error("There was a problem with the fetch operation:", error.message);
                   });
           }
       };


    handleRequestEdit= (id, description) => {
       const isConfirmed = window.confirm(`${description} Talebinizi güncellemek istediğinizden emin misiniz?`);


         if (isConfirmed) {
               const token = localStorage.getItem("accessToken");
               const apiUrl = `${API_BASE_URL}/nobettalep/${id}`;


               fetch(apiUrl, {
                   method: "PUT",
                   headers: {
                       Authorization: "Bearer " + token,
                   },
               })
                   .then((response) => {
                       if (!response.ok) {
                           throw new Error("Network response was not ok");
                       }
                       this.setState((prevState) => ({
                           requests: prevState.requests.filter((request) => request.id !== id),
                       }));
                   })
                   .catch((error) => {
                       console.error("There was a problem with the fetch operation:", error.message);
                   });
           }
       };


    handleLogout() {
        this.props.handleLogout();
    }
    cancelRequestCreation() {
        this.setState({
            isEditModalOpen: false,
            addDeleteModal: false,
            add:false,
        })
        this.fetchRequest()
    }

    handleEdit(item) {
        this.setState({
            selectedRequest: item,
            isEditModalOpen: true,
        })
    }
    handleDelete(item) {
        this.setState({
            selectedRequest: item,
            addDeleteModal: true
        })
    }

 addNew(item) {
     this.setState({
         selectedRequest: null,
         isEditModalOpen: true,
         add: true // Ekleme modunu true olarak ayarla
     });
 }

    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.fetchRequest(this.state.accessor, this.state.direction, page, this.state.size))
    }

    handleMenuClick(e) {
        let self = this;
        if (e.key === '1') {
            this.handleEdit(self.state.selectedItem);
        } else if (e.key === '2') {
            this.handleDelete(self.state.selectedItem);
        }
    }

    render() {
        let self = this;
        console.log("request", this.state.request)
        const menu = (
            <Menu onClick={self.handleMenuClick}>
                {
                    self.state.selectedItem &&
                    <Menu.Item key="1">
                       Nöbet Talep Düzenle
                    </Menu.Item>
                }
                {
                    self.state.selectedItem &&
                    <Menu.Item key="2">
                        Nöbet Talep Sil
                    </Menu.Item>
                }
            </Menu>
        );
        const columns = [
            {
                Header: "Talep Açıklama ",
                accessor: "description",
            },
            {
                Header: "Tarih",
                accessor: "date",
                Cell: (item) => (
                  <label>{new Date(item.date).toLocaleDateString("tr")}</label>
                                ),
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                    <Dropdown overlay={menu} trigger='click' onClick={() => self.setState({selectedItem: item})}>
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            }

        ];

        const fields = [
            {
                label: " Talep Açıklama",
                accessor: "description",
                type: "text",
                operator: "=",
            },
            {
                label: "Tarih",
                accessor: "date",
                type: "date",
                operator: "=",
            },

              ];


        return (
            <div className="row baseBackground">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Nöbet Talep Düzenleme İşlemleri</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div className=" ">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch
                                    fields={fields}
                                    loading={this.state.searching}
                                    onSearch={this.handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={this.state.requests}
                            total={this.state.total}
                            page={this.state.page}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.fetchRequest}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div className="new-button-holder">
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                title="Yeni Talep Ekle" disabled={this.state.isLoading}
                                style={{
                                    background: 'linear-gradient(#2b93cd, #0a66b7)',
                                    height: '40px',
                                    width: '190px',
                                    float: 'right',
                                    marginRight: '30px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                }}
                                className="TekBtn add-new-member "
                                rel="tooltip"
                                onClick={() => this.addNew(this.state.selectedItem)}>
                            YENİ NÖBET TALEP EKLE
                        </button>
                    </div>
                </div>
             <Modal isOpen={this.state.isEditModalOpen} size="lg" className="ust">
                 <ModalHeader toggle={this.cancelRequestCreation}>
                     {this.state.add ? 'Yeni Nöbet Talep Ekleme' : 'Nöbet Talep Düzenleme'}
                 </ModalHeader>
                 <ModalBody>
                     <NobetTalepForm
                         onCancel={this.cancelRequestCreation}
                         handleSearch={this.fetchRequest}
                         add={this.state.add}
                         selectedRequest={this.state.selectedRequest}
                     />
                 </ModalBody>
             </Modal>
                 <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust">
                        <ModalHeader toggle={this.cancelRequestCreation}>
                            Nöbet Talep Silme
                        </ModalHeader>
                        <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                            <TalepDeleteModal
                                cancelProcess={this.cancelRequestCreation}
                                selectedRequest={this.state.selectedRequest}
                                handleLogout={this.handleLogout}
                            />
                        </ModalBody>
                 </Modal>
            </div>
        )
    }
}

export default NobetTalep;


// WEBPACK FOOTER //
// ./src/page/nobetParams/NobetTalep.js